<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { get } from "lodash";
import VueScript from "vue-script";

export default {
  mixins: [fandomBasicMixin],
  components: {
    VueScript
  },
  methods: {
    getTarget: Fandom.getTarget,
    getBackgroundUrl: Fandom.getBackgroundUrl,
    getLangLink(lang) {
      const slug = globalState.pageModel.name_to_content[globalState.pageModel.main_content_name].slug;
      return Fandom.urljoin("/", lang, slug);
    },
    getLogoStyles(item) {
      return {
        //"background-image": this.getBackgroundUrl(item.icon.url),
        "width": item.width
      }
    }
  },
  computed: {
    availableLangs() {
      return get(this.pageModel, ['context', 'available_langs'], []);
    },
    socialIcons() {
      if (this.mainContent.social_icons) {
        return this.mainContent.social_icons;
      } else {
        const socialIcons = (this.pageModel.breadcrumb || []).filter(item => !!item.social_icons);
        return socialIcons.lenght > 0 ? socialIcons[socialIcons.lenght -1].social_icons : this.content.social_icons;
      }
    }
  }
};
</script>

<template>
  <div 
    v-if="isContentVisibleToUser()"  
    class="row mx-0 justify-content-center"
    footer-component
  >
    <div class="col-12 py-md-3 bg-gray-200">
      <div class="row py-3 py-md-4 justify-content-center">
        <div class="col-12 col-md-10">
          <div class="row align-items-center">
            <div class="col-12 py-3 py-md-0 col-md d-flex justify-content-center justify-content-md-start">
              <p class="text-uppercase mb-0" id="supported-by">{{ft("globals.supported_by")}}</p>
            </div>
            <div 
              class="col-12 col-md py-3 text-center"
              v-for="(item, key) in content.logo_carousel"
              :key="key"
            >
              <component
                :is="item.url ? 'a' : 'div'"
                :href="!!item.url ? item.url.url : 'javascript:void(0)'"
                :target="getTarget(item.url)"
              >
                <img class="logo" :src="item.icon.url" :style="getLogoStyles(item)">
              </component>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-10">
      <div class="pt-3 pt-md-5">
        <div class="row justify-content-between py-md-5 d-none d-md-flex" v-if="content.navbar">
          <div v-for="section in content.navbar" class="col-12 col-md">
            <div class="text-uppercase text-white py-2 section-title">{{section.title}}</div>
            <div v-for="(item, index) in section.items" class="w-100 py-1" :key="index">
              <a class="navbar-link" :href="item.url.url" :target="getTarget(item.url)">{{item.url.title}}</a>
            </div>
          </div>
        </div>
        <div class="row justify-content-between py-3 d-md-none" v-if="content.navbar">
          <div v-for="(section, section_index) in content.navbar" :key="`section-${section_index}`" class="col-12">
            <a
              :href="`#section-${section_index}`"
              data-toggle="collapse"
              class="font-weight-bold text-uppercase text-white py-2 section-title w-100 d-flex justify-content-between collapsed"
            >
              {{section.title}}
              <i class="far fa-chevron-up d-flex justify-content-center align-items-center"></i>
            </a>
            <div :id="`section-${section_index}`" class="collapse">
              <div v-for="(item, index) in section.items" class="w-100 py-1" :key="index">
                <a class="navbar-link" :href="item.url.url" :target="getTarget(item.url)">{{item.url.title}}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-between align-items-center py-3 py-md-4">
          <div class="col-12 col-md-6 d-flex justify-content-between justify-content-md-start">
            <div v-for="(icon, index) in socialIcons" class="mr-md-5" :key="index">
              <a :href="icon.url.url" class="social-icon" :target="getTarget(icon.url)">
                <i :class="icon.icon"></i>
              </a>
            </div>
          </div>
          <div class="col-12 col-md-6 my-3 my-md-0 d-flex justify-content-between justify-content-md-end" v-if="availableLangs.length > 1">
            <a
              v-for="(lang, li) in availableLangs"
              :key="`lang-${li}`"
              role="button"
              class="btn shadow-none btn-outline-light d-inline-block flex-fill flex-md-grow-0 flex-md-shrink-0 py-2 py-md-3" 
              :href="getLangLink(lang)"
              :class="{'disabled': globalState.lang == lang, 'mr-3 mr-md-4': li != (availableLangs.length - 1)}"
              :disabled="globalState.lang == lang"
            >{{ft(`globals.${lang}`)}}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 bg-dark py-3 py-md-0">
      <div class="row py-2 py-md-4 justify-content-center">
        <div class="col-12 col-md-10 d-flex align-items-md-center flex-column justify-content-md-between flex-md-row-reverse">
          <div class="pb-3 pb-md-0 mx-n2">
            <span v-for="(item, index) in content.navbar_bottom">
              <span v-if="index !== 0" class="text-gray-200">|</span>
              <a class="navbar-link mx-2 disclaimer" :href="item.url.url" :target="getTarget(item.url)">{{item.url.title}}</a>
            </span>
          </div>
          <span v-if="content.disclaimer" class="disclaimer">{{content.disclaimer}}</span>
        </div>
      </div>
      <div v-if="content.cookie_snippet" class="row">
        <div class="col-12 pb-3">
          <div id="consent-banner"></div>
          <div id="teconsent">
            <vue-script id="cookies-manager-test" :script="content.cookie_snippet"></vue-script>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[footer-component] {
  background-color: $gray-900;
  position: relative;
  z-index: 1021;

  a[data-toggle="collapse"] {

    & > i {
      transition: transform .25s;
    }

    &.collapsed > i {
      transform: rotate(180deg);
    }
  }

  .btn {
    width: fit-content;
  }

  #supported-by {
    font-size: .75rem;
    font-weight: 800;
  }

  .social-icon {
    font-size: 1.25rem;
    color: $gray-200;
    transition: color .25s;

    &:hover,
    &:active,
    &:focus {
      color: $gray-300;
    }
  }

  .logo {
    width: 6rem;
    max-width: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .navbar-link {
    font-weight: 300;
    color: $white;
    transition: color $animation-time-fast;

    &:hover {
      color: darken($white, 15%);
    }
  }

  .navbar-link,
  .section-title {
    font-size: .875rem;
  }

  .section-title {
    font-weight: 800;
  }

  .disclaimer {
    font-size: 0.75rem;
    color: $gray-200;
  }
  
  @include media-breakpoint-down(sm) {
    .logo {
    }
  }

}

</style>